import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import mentorsAPI, { MentorLog as MentorLogType } from '../../api/mentors';
import { PageLoader } from '../../components/common';
import { useParams } from 'react-router';
import { ListLogs } from '../../components/common/Logs/List';

const useStyles = makeStyles({
  container: {
    maxWidth: 670,
  },
  loader: {
    width: '100%',
    minHeight: 400,
    maxHeight: '100%',
    display: 'flex',
    alignItems: 'center',
  },
});

function MentorLogPage() {
  const classes = useStyles();
  const { mentorId } = useParams<{ mentorId: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const [logs, setLogs] = useState<MentorLogType[]>([]);

  const loadLogs = async (mentorId: string) => {
    try {
      setIsLoading(true);
      const responseLogs = await mentorsAPI.getLogs(mentorId);

      const sortLogs = responseLogs.sort((a, b) => {
        const prevDate = +new Date(a.creationDate);
        const nextDate = +new Date(b.creationDate);
        return nextDate - prevDate;
      });

      setLogs(sortLogs);
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadLogs(mentorId);
  }, [mentorId]);

  if (isLoading) {
    return (
      <div className={classes.loader}>
        <PageLoader />
      </div>
    );
  }

  return <ListLogs logs={logs} />;
}

export default MentorLogPage;
